import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';

const getSubscriberCount = async (type) => {
  const queryString = qs.stringify({ type });
  const { data } = await axios.get(`/api/subscribers/count?${queryString}`);
  return data;
};

export const useSubscriberCount = (type) => {
  return useQuery(['subscriber-count', type], () => getSubscriberCount(type), {
    select: ({ count }) => count,
  });
};
